export const regexValidation = {
    placa: /^(\D{3})(\d{1})([0-9A-Ja-j]{1})(\d{2})$/,
    chassis:
        /^(?:[A-Z0-9]{11}|((?![QIO])\w){9}(?![QIOUZ0])\w((?![QIO])\w){3}\d{4})$/i,
    ano: /^\d{4}$/
}

export const camelCaseToWords = (text: string) => {
    return text
        .replace(
            /([A-Z])/g,
            (match, group) =>
                (group === text[0] ? '' : ' ') + group.toLowerCase()
        )
        .toUpperCase()
}
